export default {
  props: {
    evolucionJson: {
      type: Object,
    },
    faltanCamposRequeridos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "Dato obligatorio"],
    };
  },
  watch: {
    evolucionJson: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.values = { ...this.values, ...val };
        }
      },
      immediate: true,
      deep: true,
    },
    values: {
      handler(val) {
        this.$emit("actualizaEvolucionJson", val);
      },
      deep: true,
    },
    camposRequeridos: {
      handler(val) {
        this.$emit("update:faltanCamposRequeridos", val);
      },
      immediate: true,
    },
  },
};
